import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StatisticsConfig, Partner, EngineStatisticsService } from '@tj/tj-dmp-lib-api';
import { ChartOptions } from 'chart.js';
import { min } from 'lodash';
import { ChartComponent } from 'ng-apexcharts';


export interface Airport{
  id: number;
  name: string;
}



@Component({
    selector: 'dmp-statistics-graph2',
    templateUrl: './statistics-graph2.component.html',
    styleUrls: ['./statistics-graph2.component.scss'],
    standalone: false
})
export class StatisticsGraph2Component implements OnInit, OnChanges {
  @ViewChild("chart") chart: ChartComponent;
  @Input() codeTenant: string;
  @Input() config: StatisticsConfig;
  @Input() partners: Array<Partner> = [];
  public chartOptions: any;
  public data: Map<string, number> = new Map<string, number>();
  public airports: Array<string> = [];
  public airportsMultiSelect: Array<Airport> = [];
  public selectedAirports: Array<Airport> = [];
  public parametersOne: Array<string> = ["origin", "destination", "route"];
  public selectedParameterOne = "origin";
  public parametersTwo: Array<string> = ["bookings", "passengers", "sells"];
  public selectedParameterTwo = "bookings";
  customStartDate = localStorage.getItem("customStartDate") ? new Date(localStorage.getItem("customStartDate")) : this.getLastThreeMonth();
  customEndDate = localStorage.getItem("customEndDate") ? new Date(localStorage.getItem("customEndDate")) : this.getToday();


  constructor(private readonly translate: TranslateService,
              private readonly engineStatisticsService: EngineStatisticsService,
              private readonly changeDetectorRef: ChangeDetectorRef) {
   }

  initChart(): void {
    this.chartOptions = {
      series: [
        {
          data: []
        }
      ],
      chart: {
        height: 350,
        type: "bar"
      },
      plotOptions: {
        bar: {
          dataLabels: {
            position: "top" // top, center, bottom
          }
        }
      },
      dataLabels: {
        enabled: true,
        offsetY: -20,
        style: {
          fontSize: "12px",
          colors: ["#304758"]
        }
      },

      xaxis: {
        categories: [
        ],
        position: "bottom",

        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        },
        crosshairs: {
          fill: {
            type: "gchartradient",
            gradient: {
              colorFrom: "#D8E3F0",
              colorTo: "#BED1E6",
              stops: [0, 100],
              opacityFrom: 0.4,
              opacityTo: 0.5
            }
          }
        },
        tooltip: {
          enabled: true,
          offsetY: -35
        }
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "light",
          type: "horizontal",
          shadeIntensity: 0.25,
          gradientToColors: undefined,
          inverseColors: true,
          opacityFrom: 1,
          opacityTo: 1,
          stops: [50, 0, 100, 100]
        }
      },
      yaxis: {
        axisBorder: {
          show: false
        },
        axisTicks: {
          show: false
        },
        labels: {
          show: false,
          formatter: function(val) {
            return val;
          }
        }
      }
    };
  } 

  ngOnChanges(): void {
    this.initChart();
    this.getData("filter", this.customStartDate, this.customEndDate, this.selectedParameterOne, this.selectedParameterTwo);
    this.changeDetectorRef.detectChanges();
  }

  public dateToIsoString(date: Date) {
    return date.toISOString().split('T')[0];
  }

  public updateChart() {
    if (!this.chart || !this.chartOptions) {
      setTimeout(() => this.updateChart(), 0);
      return;
    }
    this.chart.updateSeries(this.chartOptions.series);
    this.chart.updateOptions(this.chartOptions, false, true, true);
  }

  public emptyChart() {
    this.chartOptions.series[0].data = [];
    this.chartOptions.xaxis.categories = [];
    this.updateChart();
  }


  public async getData(serie: string, startDate: Date, endDate: Date, param1: string, param2: string) {
    const resultDataStatisticsDto = await this.engineStatisticsService.getDataUsingPOST(this.codeTenant, this.config.code, this.dateToIsoString(endDate), this.partners.map(p=>p.code) ,this.dateToIsoString(startDate), {"serie":serie, "param1": param1, "param2": param2}).toPromise();
    for (let i = 0; i < min([resultDataStatisticsDto.series[0].data.length, 10]); i++) {
      this.chartOptions.series[0].data.push(resultDataStatisticsDto.series[0].data[i][1]);
      this.chartOptions.xaxis.categories.push(resultDataStatisticsDto.series[0].data[i][0]);
      this.selectedAirports.push({
        "id": i,
        "name": resultDataStatisticsDto.series[0].data[i][0]
      });
    }
    resultDataStatisticsDto.series[0].data.forEach((element, index) => {
      this.data[element[0]] = element[1];
      this.airports.push(element[0]);
      this.airportsMultiSelect.push({
        "id": index,
        "name": element[0]
      });
    });
    this.chartOptions.series[0].name = resultDataStatisticsDto.series[0].label;
    this.updateChart();
  }

  public selectAirport() {
    this.chartOptions.series[0].data = [];
    this.chartOptions.xaxis.categories = [];
    this.selectedAirports.forEach(airport => {
      this.chartOptions.series[0].data.push(this.data[airport['name']]);
      this.chartOptions.xaxis.categories.push(airport['name']);
    });
    this.updateChart();
  }



  public reset() {
    this.emptyChart();
    this.selectedAirports = [];
    for (let i = 0; i < min([this.airports.length, 10]); i++) {
      this.chartOptions.series[0].data.push(this.data[this.airports[i]]);
      this.chartOptions.xaxis.categories.push(this.airports[i]);
      this.selectedAirports.push({
        "id": i,
        "name": this.airports[i]
      });
    }
    this.updateChart();
  }



  public selectParameter() {
    this.emptyChart();
    this.selectedAirports = [];
    this.airports = [];
    this.airportsMultiSelect = [];
    this.getData("filter", this.customStartDate, this.customEndDate, this.selectedParameterOne, this.selectedParameterTwo);
  }

  ngOnInit(): void {
    
  }

  public getToday() : Date {
    return new Date();
  }

  public getLastThreeMonth() : Date {
    const today = new Date();
    return new Date(today.getFullYear(), today.getMonth() - 3, today.getDate());
  }

  public updateRangeOfChart() {
    this.emptyChart();
    this.selectedAirports = [];
    this.airports = [];
    this.airportsMultiSelect = [];
    this.getData("filter", this.customStartDate, this.customEndDate, this.selectedParameterOne, this.selectedParameterTwo);
  }
}
